import React, { useState } from "react";
import { graphql } from "gatsby";
import Layout from "../components/layout";
import SEO from "../components/seo";
import PeopleItem from "../components/PeopleItem";

const People = ({ data, location }) => {
  const [value, setValue] = useState(1);

  const siteTitle = data.site.siteMetadata.title;
  const posts = data.allMarkdownRemark.edges;
  const images = data.allImageSharp.edges;

  let showPosts = posts.slice(0, 6 * value);
  let morePosts = showPosts.length < posts.length;

  function loadMore() {
    setValue((value) => ++value);
  }

  return (
    <Layout location={location} title={siteTitle}>
      <SEO title="People" />
      {showPosts.map(({ node }) => {
        return (
          <PeopleItem
            node={node}
            allImages={images}
            key={node.frontmatter.slug}
          />
        );
      })}
      <div style={{ clear: `both` }}></div>
      <div
        onClick={loadMore}
        style={{
          width: `190px`,
          margin: `auto`,
          height: `70px`,
          background: `#EBEBEB`,
          cursor: `pointer`,
          display: morePosts ? `block` : `none`,
        }}
      >
        <p
          style={{
            textAlign: `center`,
            fontSize: `30px`,
            lineHeight: `70px`,
            fontFamily: "Amatic SC",
          }}
        >
          Load More
        </p>
      </div>
    </Layout>
  );
};

export default People;

export const pageQuery = graphql`
  query {
    site {
      siteMetadata {
        title
      }
    }
    allMarkdownRemark(
      filter: { frontmatter: { template: { eq: "people" } } }
      sort: { fields: [frontmatter___date], order: DESC }
    ) {
      edges {
        node {
          excerpt
          fields {
            slug
          }
          html
          frontmatter {
            date(formatString: "MMMM DD, YYYY")
            title
            images
            slug
            description
            tags
          }
        }
      }
    }
    allImageSharp {
      edges {
        node {
          fluid {
            aspectRatio
            base64
            tracedSVG
            srcWebp
            srcSetWebp
            originalImg
            originalName
          }
        }
      }
    }
  }
`;
